<template lang="pug">
.styles-wrap
  .styles
    .blank
    .style(v-for="[size, kind] in ['large', 'mid', 'small'].reduce(legendValueCoreGrowth, [['legend', 'value'], ['legend', 'core'], ['legend', 'growth']])"
           :class="{ selected: styleFilter && styleFilter === [size, kind].join('|') || styleFilter === ['*', kind].join('|') || styleFilter === [size, '*'].join('|') }",
           @click="setStyleFilter(size, kind)",
           :title="[size, kind].join(' ').replace(/legend/, '').trim()"
           :size="size",
           :kind="kind")
  .label {{ (styleFilter || '').replace(/\|/, ' ').replace(/^\*/, 'all ').replace(/([^\*]+)\*$/, 'all $1') || 'all styles' }}
</template>
<script>
import { vuexComputed } from '@/helpers';
export default {
  name: 'styles',
  computed: {
    ...vuexComputed('styleFilter')
  },
  methods: {
    legendValueCoreGrowth(all, size) {
      ['legend', 'value', 'core', 'growth'].forEach(t => all.push([size, t]));
      return all;
    },
    setStyleFilter: function(size, kind) {
      const { styleFilter } = this;
      // const sizeKind = ['size', 'kind'].map(p => target.getAttribute(p)).join('|');
      const sizeKind = [size, kind].join('|').replace(/legend/, '*');
      this.styleFilter = (sizeKind !== styleFilter && sizeKind) || null;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.styles-wrap {
  position: relative;
  $size: 0.75rem;
  display: flex;
  .label {
    margin-top: $size * 1.7;
    font-family: 'Assistant', sans-serif;
    padding-left: 0.5rem;
    color: $brn;
    text-transform: uppercase;
    font-size: 0.9rem;
    min-width: 6.1rem;
  }
  .styles {
    display: grid;
    grid-template-columns: repeat(4, $size);
    grid-gap: 0.25rem;
    box-sizing: border-box;
    transform: scale(0.9);
    transform-origin: center;
    .blank {
      pointer-events: none;
    }
    .style {
      cursor: pointer;
      position: relative;
      box-sizing: border-box;
      height: $size;
      background-color: #f9f9f9;
      border-radius: 50%;
      transform-origin: top center;
      font-size: 0.1rem;
      transition: all 250ms ease-in-out;
      &[size="mid"],
      &[size="small"] {
        //transform: scale(0.75);
        &::before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          bottom: -1px;
          right: -1px;
          border: 2px solid white;
          border-radius: 50%;
        }
      }
      &[size="small"] {
        &::before {
          border-width: 3px;
        }
        //transform: scale(0.6) translate3d(0, -0.25rem, 0);
      }
      &[size="legend"][kind="value"],
      &.selected[kind="value"],
      &:hover[kind="value"] {
        background-color: rgba($brn, 0.467);
      }
      &[size="legend"][kind="core"],
      &.selected[kind="core"],
      &:hover[kind="core"] {
        background-color: #dadada;
      }
      &[size="legend"][kind="growth"],
      &.selected[kind="growth"],
      &:hover[kind="growth"] {
        background-color: orange;
      }
      &[kind="legend"] {
        //cursor: default;
        background-color: $brn;
      }
      &[size="legend"] {
        //cursor: default;
        border-radius: 0.25rem;
      }
    }
  }
}
</style>
